import { useModal } from "@ebay/nice-modal-react";
import style from "./ModalBase.module.css"
import { useEffect, useState, forwardRef, useImperativeHandle, useCallback } from "react";
import ModalBaseHeader from "./ModalBaseHeader";
import ModalBaseMain from "./ModalBaseMain";
import ModalBaseFooter from "./ModalBaseFooter";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";

const ModalBase = forwardRef((props, ref) => {
    const modal = useModal();
    useImperativeHandle(ref, () => ({
        close() {
            modalClose();
        }
    }));

    const [maskHeight, setMaskHeight] = useState(document.documentElement.clientHeight);
    const [mouseDownElement, setMouseDownElement] = useState('');
    const [mouseUpElement, setMouseUpElement] = useState('');
    const preventOverlayScroll = () => {
        document.body.style.cssText = `overflow-y: hidden;`;
    }

    const restoreOverlayScroll = () => {
        document.body.style.cssText = `overflow-y: unset;`;
    }

    preventOverlayScroll();

    const modalClose = () => {
        if (mouseDownElement === mouseUpElement) {
            restoreOverlayScroll();
            modal.remove();
        }
    }

    const onClickOutside = (e) => {
        if (props.clickOutsideToClose) {
            modalClose();
        }
    }
    const insideClickPropagation = (e) => {
        e.stopPropagation();
    }

    const onMouseDown = (e) => {
        setMouseDownElement(e.target);
    }

    const onMouseUp = (e) => {
        setMouseUpElement(e.target);
    }

    const keyFunction = useCallback((event) => {
        if (event.keyCode === 27) {
            modalClose();
        } else {
            if (props.onKeyPress) {
                props.onKeyPress(event);
            }
        }
    }, []);

    useEffect(() => {
        document.addEventListener("keydown", keyFunction);
        return () => {
            document.removeEventListener("keydown", keyFunction);
        };
    }, [keyFunction]);

    const { padding } = props;

    useEffect(()=> {
        // console.log(maskHeight);
    }, [maskHeight]);

    return (
        <div className={style.mask} style={{ height: "1000vh" }} onClick={onClickOutside} onMouseUp={onMouseUp} onMouseDown={onMouseDown}>
            <div className={style.wrap}>
                <div className={style.modal} style={{ width: props.width, height: props.height, padding: props.padding }} onClick={insideClickPropagation} onMouseUp={onMouseUp} onMouseDown={onMouseDown}>
                    <VerticalFlex>
                        {props.withHeader ?
                            <FlexChild height={50}>
                                <ModalBaseHeader title={props.title} modalClose={modalClose} />
                            </FlexChild>
                            : null}
                        <FlexChild>
                            <ModalBaseMain withCloseButton={props.withHeader || props.withFooter ? false : props.withCloseButton} modalClose={modalClose} padding={padding}>
                                {props.children}
                            </ModalBaseMain>
                        </FlexChild>

                        {props.withFooter ?
                            <FlexChild height={50}>
                                <ModalBaseFooter buttonText={props.buttonText} modalClose={modalClose} />
                            </FlexChild>
                            : null}
                    </VerticalFlex>
                </div>
            </div>

        </div>
    );
});

export default ModalBase;